<template>
  <div class="senditTableWrapper">
    <CContainer v-if="!noData">
      <CRow>
        <CContainer>
          <CRow>
            <CCol xs="12" sm="12">
              <slot name="filters-top"></slot>
            </CCol>
            <CCol sm="5" class="d-flex flex-column justify-content-center" v-if="searchable">
              <CRow class="mb-3">
                <CCol>
                  <form @submit.prevent :class="searchClasses">
                    <CInput
                      type="search"
                      v-model="searchValue"
                      @input="search"
                      :placeholder="searchPlaceholder"
                      addInputClasses="pl-5"
                      class="iconSearchPlaceholder-table text-left newInput"
                    >
                    </CInput>
                  </form>
                </CCol>
              </CRow>
              <slot name="filters-left-down"></slot>
            </CCol>
            <CCol sm="7">
              <slot name="filters-right">
                <!-- Quando for adicionar um filtro, basta faze-lo dentro do slot pelo component pai -->
                <!-- <form class="bg-white shadow-md rounded px-8 pt-6 pb-8" @submit.prevent>
                  <div class="mb-4">
                    <span class="block text-gray-600 text-sm text-left font-bold mb-2">Select Range</span>
                    <v-date-picker v-model="range" mode="dateTime" :masks="masks" is-range>
                      <template v-slot="{ inputValue, inputEvents, isDragging }">
                        <div class="flex flex-col sm:flex-row justify-start items-center">
                          <div class="relative flex-grow">
                            <svg
                              class="text-gray-600 w-4 h-full mx-2 absolute pointer-events-none"
                              fill="none"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                            </svg>
                            <input
                              class="flex-grow pl-8 pr-2 py-1 bg-gray-100 border rounded w-full"
                              :class="isDragging ? 'text-gray-600' : 'text-gray-900'"
                              :value="inputValue.start"
                              v-on="inputEvents.start"
                            />
                          </div>
                          <span class="flex-shrink-0 m-2">
                            <svg class="w-4 h-4 stroke-current text-gray-600" viewBox="0 0 24 24">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                            </svg>
                          </span>
                          <div class="relative flex-grow">
                            <svg
                              class="text-gray-600 w-4 h-full mx-2 absolute pointer-events-none"
                              fill="none"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                            </svg>
                            <input
                              class="flex-grow pl-8 pr-2 py-1 bg-gray-100 border rounded w-full"
                              :class="isDragging ? 'text-gray-600' : 'text-gray-900'"
                              :value="inputValue.end"
                              v-on="inputEvents.end"
                            />
                          </div>
                        </div>
                      </template>
                    </v-date-picker>
                  </div>
                </form> -->
              </slot>
            </CCol>
          </CRow>
        </CContainer>
        <CCol xs="12" sm="12" class="px-3 d-flex action-filters-area align-items-center">
          <CRow v-if="selectable">
            <CCol v-if="selectionType == 'checkbox'">
              <div class="pt-1" v-if="selectable && selectionType == 'checkbox'">
                <CInputCheckbox custom @update:checked="selectAllRegisters" />
              </div>
            </CCol>
            <CCol>
              <slot name="select-actions"></slot>
            </CCol>
          </CRow>
        </CCol>
      </CRow>
      <CDataTable
        :ref="tableRefName"
        :sorter="sortable"
        :items="registersData"
        :fields="headersData"
        @row-clicked="() => {}"
        hover
        :loading="loading"
        class="senditTable"
        :class="{ [customClassesTable]: customClassesTable.length > 0 }"
        @onSorterValueChange="emitSorterChange"
        @sort-changed="emitSorterChange"
      >
        <template #loading>
          <!-- <div class="d-flex justify-content-center align-items-center w-100">
            <CSpinner class="m-3" color="primary" />
          </div> -->
        </template>

        <!-- eslint-disable-next-line -->
        <template #select="{ item }">
          <td @click.stop>
            <CInputCheckbox
              v-if="selectionType == 'checkbox'"
              :checked.sync="item._selected"
              @update:checked="selectRegister"
              class="text-center checkboxTable"
              custom
            />
            <CInputRadio
              v-if="selectionType == 'radio'"
              :checked.sync="item._selected"
              name="table-radio"
              @update:checked="selectRegisterRadio(item)"
              class="text-center checkboxTable"
              custom
            />
          </td>
        </template>

        <template v-for="field in headers" v-slot:[field.key]="item">
          <slot :name="field.key" :item="item.item">
            <!-- eslint-disable-next-line -->
            <td>{{ item.item[field.key] }}</td>
          </slot>
        </template>

        <template #expand-column="{ item, index }">
          <td class="text-right" style="cursor: pointer" @click="toggleDetails(item, index)">
            <span>
              <u class="text-capitalize">{{ item._expanded ? expandText[1] : expandText[0] }}</u>
              <CIcon :class="item._expanded ? 'invert-icon' : ''" name="arrow" class="mx-1" size="custom-size" :height="15" viewBox="0 0 32 32" />
            </span>
          </td>
        </template>

        <template #no-items-view>
          <slot name="no-items">
            <CCol xs="12" sm="6" class="offset-sm-3 text-center emptyCard d-flex flex-column content-center justify-content-center">
              <div>
                <figure class="mb-5">
                  <img src="/img/site/amico.png" alt="" width="181" />
                </figure>
                <h3 class="mb-3">
                  {{ $t('invoices.list.table.empty.title') }}
                </h3>
                <p class="px-5 text-gray-700">
                  {{ $t('invoices.list.table.empty.description') }}
                </p>
              </div>
            </CCol>
          </slot>
        </template>

        <template #details="{ item }">
          <CCollapse :show="Boolean(item._expanded)">
            <slot name="expanded-area" :item="removeFieldNewField(item)"></slot>
          </CCollapse>
        </template>
      </CDataTable>
      <CRow class="my-3">
        <CCol>
          <slot name="footer-left"></slot>
        </CCol>
        <CCol>
          <div v-if="pagination" class="position-relative">
            <CPagination
              align="end"
              v-show="totalPages > 0"
              class="text-gray-800 m-0"
              color="text-gray-800"
              :doubleArrows="true"
              :pages="totalPages"
              :active-page="currentPage"
              @update:activePage="updatePagination"
              ref="pagination"
            >
              <template slot="previous-button">
                <span class="d-flex content-center">
                  <i class="icon fas fa-angle-left font-weight-light mx-2"></i>
                  <span>
                    {{ $t('general.components.table.pagination.prev') }}
                  </span>
                </span>
              </template>

              <template slot="next-button">
                <span class="d-flex content-center">
                  <span>
                    {{ $t('general.components.table.pagination.next') }}
                  </span>
                  <i class="icon fas fa-angle-right font-weight-light mx-2"></i>
                </span>
              </template>

              <template slot="first-button">
                <span class="d-flex content-center"> {{ $t('general.components.table.pagination.first') }} </span>
              </template>

              <template slot="last-button">
                <span class="d-flex content-center">
                  {{ $t('general.components.table.pagination.last') }}
                </span>
              </template>
            </CPagination>
            <CElementCover v-if="loading" :opacity="0.8" style="z-index: 1001">
              <div></div>
            </CElementCover>
          </div>
        </CCol>
      </CRow>
    </CContainer>
    <CContainer v-else>
      <slot name="empyt-table">
        <CCol xs="12" sm="6" class="offset-sm-3 text-center emptyCard d-flex flex-column content-center justify-content-center">
          <div>
            <figure class="mb-5">
              <img src="/img/site/amico.png" alt="" width="181" />
            </figure>
            <h3 class="mb-3">
              {{ $t('general.components.table.box-empty.title') }}
            </h3>
            <p class="px-5 text-gray-700">
              {{ $t('general.components.table.box-empty.description') }}
            </p>
          </div>
        </CCol>
      </slot>
    </CContainer>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
export default {
  name: 'SenditTable',
  props: {
    // ? há Registros
    noData: {
      type: Boolean,
      default: () => false,
    },
    // ? Registros que irão ser listados
    registers: {
      type: Array,
      default: () => [],
    },
    // ? Cabeçalho da tabela
    headers: {
      type: Array,
      default: () => [],
    },
    // ? Exibe o loading da tabela
    loading: {
      type: Boolean,
      default: false,
    },
    // ? Diz se a tabela tem paginação ou não
    pagination: {
      type: Boolean,
      default: false,
    },
    // ? Quantidade de itens por página
    itemsPerPage: {
      type: Number,
      default: 10, // Valor que normalmente é usado ao longo da aplicação
    },
    // ? Página que está selecionada
    currentPage: {
      type: Number,
      default: 0,
    },
    // ? Total de páginas
    totalPages: {
      type: Number,
      default: 0,
    },
    // ? Total de registros
    totalRecords: {
      type: Number,
      default: 0,
    },
    // ? Diz se poderá haver ordenação de colunas pelos cabeçalhos
    // OBS: Se for odernação pelo backend deve se passar um objeto { external: true } conforme docs do CoreUI
    sortable: {
      type: Boolean | Object,
      default: false,
    },
    // ? Diz se poderá haver seleção de linhas
    selectable: {
      type: Boolean,
      default: false,
    },
    // ? Tipo de seleção de linhas
    selectionType: {
      type: String,
      default: 'checkbox', // checkbox ou radio
    },
    // ? Pode expandir a o contúdo da linha
    expandable: {
      type: Boolean,
      default: false,
    },
    // ? Texto utilizado na mensagem que irá expandir
    expandText: {
      type: Array,
      default: () => ['Details', 'Details'],
    },
    expandHeaderText: {
      type: String,
      default: null,
    },
    // ? Diz se é possível realizar buscas na tabela
    searchable: {
      type: Boolean,
      default: false,
    },
    // ? Texto que irá no placeholder do campo de pesquisa
    searchPlaceholder: {
      type: String,
      default: 'Search',
    },
    // ? Tempo de intervalo entre o tempo que o ultimo caractere foi digitado e o início da busca
    searchTime: {
      type: Number,
      default: 1500,
    },
    // ? Classes CSS aplicadas no input do search
    searchClasses: {
      type: String,
      default: '',
    },
    // ? Propriedade que determina se o texto passado no label dos headers utilizará às traduções
    // ? caso seja verdadeira, o componente passará o texto como parâmetro para a função $t de tradução
    translateHeader: {
      type: Boolean,
      default: false,
    },
    // ? Array de classes customizadas para senditTable
    customClassesTable: {
      type: Array,
      default: () => [],
    },
    // ? Define se a ordenação será feita pelo backend
    sortByBackend: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      headersData: [],
      registersData: [],
      selectedRegisters: [],
      searchTimeout: null,
      searchValue: '',
      range: {
        start: new Date(2020, 0, 6),
        end: new Date(2020, 0, 23),
      },
      masks: {
        input: 'YYYY-MM-DD h:mm A',
      },
    }
  },
  created() {
    this.init()
  },
  mounted() {
    if (this.sortable && this.sortByBackend) {
      this.sorter = {}
      this.setSorterWatcher()
    }
  },
  computed: {
    tableRefName() {
      return `CDataTableRef${uuidv4()}`
    },
    tableRef() {
      return this.$refs[this.tableRefName].sorterState
    },
  },
  methods: {
    setSorterWatcher() {
      this.$watch(
        () => this.$refs[this.tableRefName].sorterState,
        (newSorterState) => this.emitSorterChange(newSorterState),
        { deep: true },
      )
    },
    updatePagination(currentPage) {
      this.$emit('updatePage', currentPage)
    },

    emitSorterChange(sorterState) {
      this.$emit('sorterChange', sorterState)
    },

    // Início Funções de seleção de linhas
    selectRegister() {
      this.selectedRegisters = []
      let registers = JSON.parse(JSON.stringify(this.registersData.filter((elm) => elm._selected)))
      this.selectedRegisters = this.removeAuxFields(registers)
      let result = JSON.parse(JSON.stringify(this.selectedRegisters))
      this.$emit('selectRow', result)
    },
    selectRegisterRadio(value) {
      this.selectedRegisters = []
      this.registersData.forEach((elm) => (elm._selected = false))
      let registers = [JSON.parse(JSON.stringify(value))]
      this.selectedRegisters = this.removeAuxFields(registers)
      let result = JSON.parse(JSON.stringify(this.selectedRegisters))
      this.$emit('selectRow', result)
    },
    selectAllRegisters(value) {
      this.registersData.forEach((elm) => (elm._selected = value))
      this.selectedRegisters = []
      let registers = JSON.parse(JSON.stringify(this.registersData.filter((elm) => elm._selected)))
      this.selectedRegisters = this.removeAuxFields(registers)
      let result = JSON.parse(JSON.stringify(this.selectedRegisters))
      this.$emit('selectRow', result)
    },
    // Fim Funções de seleção de linhas

    // Início das funções de expandir
    toggleDetails(item, index) {
      item._expanded = !item._expanded
    },
    // Fim das funções de expandir

    // Início das funções de busca
    search() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout)
      }

      this.searchTimeout = setTimeout(() => {
        this.$emit('search', this.searchValue)
      }, this.searchTime)
    },
    // Fim das funções de busca

    removeAuxFields(array) {
      return array.map((elm) => {
        return this.removeField(elm)
      })
    },

    removeField(field) {
      delete field._selected
      delete field._expanded
      return field
    },

    removeFieldNewField(campo) {
      let field = JSON.parse(JSON.stringify(campo))
      delete field._selected
      delete field._expanded
      return field
    },

    handlerHeaderLabel(headers) {
      let headersTemp = []
      if (!Array.isArray(headers)) {
        throw Error('Invalid Headers array')
      }

      headers.forEach((element) => {
        if (typeof element == 'string') {
          headersTemp.push({ key: element, label: element, sorter: element.sorter })
        } else if (typeof element == 'object') {
          if (!element.key) {
            throw Error('Invalid Key')
          }

          if (this.translateHeader) {
            headersTemp.push({
              key: element.key,
              label: this.$t(element.label),
              sorter: element.sorter,
              _classes: element._classes,
            })
          } else {
            headersTemp.push({
              key: element.key,
              label: element.label,
              sorter: element.sorter,
              _classes: element._classes,
            })
          }
        } else {
          throw Error('Invalid object type')
        }
      })

      return headersTemp
    },

    init() {
      let headersTemp = this.handlerHeaderLabel(JSON.parse(JSON.stringify(this.headers)))
      let registersTemp = JSON.parse(JSON.stringify(this.registers))

      if (this.selectable) {
        headersTemp.unshift({
          key: 'select',
          label: '',
          _classes: 'hidde',
          _style: 'width:50px',
        })

        registersTemp.forEach((elm) => {
          elm._selected = false
        })
      }

      if (this.expandable) {
        headersTemp.push({
          key: 'expand-column',
          label: this.expandHeaderText ?? 'detail',
          _classes: 'hidde text-right',
        })

        registersTemp.forEach((elm) => {
          elm._expanded = false
        })
      }

      this.headersData = headersTemp
      this.registersData = registersTemp
    },

    noRecordsForFilters() {
      return (
        this.totalRegisters == 0 &&
        (this.searched == '' || this.filterByOptionsSelected.key == null || this.range.start == null || this.range.end == null)
      )
    },
  },

  watch: {
    registers() {
      this.init()
    },
    headers() {
      this.init()
    },
  },
}
</script>

<style lang="scss">
.senditTableWrapper {
  .senditTable {
    &.--overflow-hidden {
      .table-responsive {
        overflow-x: unset;
      }
    }
    .table tr {
      &:hover {
        background: transparent;
      }

      th {
        text-transform: uppercase;
        border-top: 0;
        border-bottom: 0;
        font-size: 14px;
      }

      td {
        padding: 0.75rem;
      }
    }
    .tooltip-old-inner {
      background: var(--white);
      color: var(--text-gray-500);
      box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.1);
    }
    .tooltip-old {
      opacity: 1;
    }

    .bs-tooltip-old-auto[x-placement^='bottom'] .arrow:before,
    .bs-tooltip-old-bottom .arrow:before {
      border-bottom-color: var(--while);
    }
  }

  ul.pagination {
    margin-bottom: 0;
  }
}
.invert-icon {
  transform: rotate(180deg);
}

.separator {
  border-bottom: 1px solid #7f889a;
}

.iconSearchPlaceholder-table {
  position: relative;
}

.iconSearchPlaceholder-table::after {
  content: '\f002';
  font-size: 20px;
  top: 30%;
  width: 50px;
  color: var(--gray-700);
  text-align: center;
  line-height: 50px;
  position: absolute;
  display: inline;
  font-family: 'Font Awesome 5 Pro';
  font-weight: 300;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
}
</style>
